<template>
    <ais-instant-search index-name="jazyky_master"
                        :search-client="searchClient"
                        @result="onResult"
                        :routing="routing"
    >

      <ais-stats>
        <template v-slot="{ nbHits }">
          <div class="jumbotron-cms">
            <div class="container pt-4 pb-2 text-center">
              <h1 class="with-border"> JAZYKOVÉ KURZY ({{ nbHits }})
              </h1>
            </div>
          </div>
        </template>
      </ais-stats>
    <div class="bg-gray-lighter--bordered pt-3 pb-4">
      <div class="container">
        <div class="row">
          <div class="col-md-3 facets pt-3">

            <h4>Vyhledávání</h4>
            <ais-search-box placeholder=""/>
            <div class="cat-filter--button">
              <a class="btn btn-primary btn-sm" data-toggle="collapse" href="#filtrovani" role="button"
                 aria-expanded="true" aria-controls="filtrovani">
                FILTROVÁNÍ
              </a>
            </div>
            <div class="cat-filter--filter" id="filtrovani">
              <div class="facets__block mt-4">
                <!--              <ais-sort-by-->
                <!--                  :items="[{-->
                <!--                    value: 'dev_lowprice_1week', label: 'cena za týden',-->
                <!--                  }]"/>-->

                <ais-clear-refinements>
                  <template v-slot="{ canRefine, refine, createURL }">
                    <a
                        :href="createURL()"
                        @click.prevent="refine"
                        v-if="canRefine"
                        class="btn btn-sm btn-primary">
                      Vymazat filtr
                    </a>
                    <div v-else>
                    </div>
                  </template>
                </ais-clear-refinements>

                <span class="facets__name">Jazyk</span>
                <ais-refinement-list
                    :class-names="{
                    'ais-RefinementList-count': 'count',
                    // ...
                  }"
                    attribute="languages.name"
                    :limit="100"
                />
                <span class="facets__name">Kategorie</span>
                <!--              <ais-refinement-list-->
                <!--                  :limit="100"-->
                <!--                  attribute="categories.name"-->
                <!--                  :transformItems="transformCategory"-->
                <!--                  :class-names="{-->
                <!--                  'ais-RefinementList-count': 'count',-->
                <!--                  // ...-->
                <!--                  }"/>-->
                <ais-refinement-list
                    :limit="100"
                    attribute="categories.name"
                    :class-names="{
                  'ais-RefinementList-count': 'count',
                  // ...
                  }"/>
                <span class="facets__name">Stát</span>
                <ais-refinement-list
                    attribute="states.name"
                    :limit="100"
                    :class-names="{
                  'ais-RefinementList-count': 'count',
                  // ...
                  }">
                  <template v-slot:showMoreLabel="{ isShowingMore }">
                    {{ !isShowingMore ? 'Více' : 'Méně' }}
                  </template>
                </ais-refinement-list>

                <span class="facets__name">město</span>
                <ais-refinement-list
                    attribute="cities.name"
                    :limit="100"
                    :class-names="{
                  'ais-RefinementList-count': 'count',
                  // ...
                  }">
                  <!--                <template v-slot:showMoreLabel="{ isShowingMore }">-->
                  <!--                  {{ !isShowingMore ? 'Více' : 'Méně' }}-->
                  <!--                </template>-->
                </ais-refinement-list>

                <ais-configure :hitsPerPage="20"/>
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <div class="category">
              <ais-hits>
                <template v-slot="{ items }">

                  <div class="d-none">
                    {{ this.totalHits = items.length }}
                  </div>

                  <div v-if="items.length > 0">
                    <div class="category__item" v-for="item in items" :key="item.objectID">
                      <kurz-banner :item="item"></kurz-banner>
                    </div>
                  </div>
                  <div v-else>
                    <p>Žádné kurzy nebyly nalezeny </p>
                  </div>
                </template>
              </ais-hits>
            </div>
            <ais-pagination v-if="totalHits > 0">
              <template
                  v-slot="{
                currentRefinement,
                nbPages,
                pages,
                isFirstPage,
                isLastPage,
                refine,
                createURL,
            }">
                <ul class="ais-Pagination-list">
                  <li v-if="!isFirstPage" class="ais-Pagination-item">
                    <a :href="createURL(0)" @click.prevent="refine(0)" class="btn btn-primary">
                      první
                    </a>
                  </li>

                  <li v-if="!isFirstPage" class="ais-Pagination-item">
                    <a
                        :href="createURL(currentRefinement - 1)"
                        @click.prevent="refine(currentRefinement - 1)"
                        class=" btn btn-primary">
                      předchozí
                    </a>
                  </li>
                  <li v-for="page in pages" :key="page" class="ais-Pagination-item d-none d-md-block">
                    <a
                        :href="createURL(page)"
                        :style="{ fontWeight: page === currentRefinement ? 'bold' : ''}"
                        :class="{ 'btn btn-secondary' : (page === currentRefinement), 'btn btn-primary d-none d-md-block' : (page !== currentRefinement) }"
                        @click.prevent="refine(page)">
                      {{ page + 1 }}
                    </a>
                  </li>
                  <li class="ais-Pagination-item d-inline-block d-md-none">
                    <a
                        :href="createURL(currentRefinement)"
                        :style="{ fontWeight: 'bold'}"
                        :class="'btn btn-secondary'"
                        @click.prevent="refine(currentRefinement)">
                      {{ currentRefinement + 1 }}
                    </a>
                  </li>
                  <li v-if="!isLastPage" class="ais-Pagination-item">
                    <a
                        :href="createURL(currentRefinement + 1)"
                        @click.prevent="refine(currentRefinement + 1)"
                        class=" btn btn-primary">
                      další
                    </a>
                  </li>
                  <li v-if="!isLastPage" class="ais-Pagination-item">
                    <a :href="createURL(nbPages)" @click.prevent="refine(nbPages)" class="btn btn-primary">
                      poslední
                    </a>
                  </li>
                </ul>
              </template>
            </ais-pagination>
          </div>
        </div>
      </div>
    </div>
    </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite';
// import {watch} from 'vue';

import 'instantsearch.css/themes/algolia-min.css';
import {
  // AisSortBy,
  AisInstantSearch,
  AisSearchBox,
  AisHits,
  AisRefinementList,
  AisConfigure,
  AisClearRefinements,
  AisPagination,
} from 'vue-instantsearch/vue3/es';
import KurzBanner from "@/components/kurz-banner.vue";
import {useRoute} from "vue-router";

function uniqBy(items, property) {
  const seen = {};

  return items.filter(item => {
    const val = item[property];

    if (seen[val]) {
      return false;
    } else {
      seen[val] = true;
      return true;
    }
  });
}

export default {
  name: 'App',
  components: {
    // AisSortBy,
    AisPagination,
    KurzBanner,
    AisInstantSearch,
    AisSearchBox,
    AisHits,
    AisRefinementList,
    AisConfigure,
    AisClearRefinements
  },
  setup() {
    const route = useRoute();
    // watch(() => route.query.search, (newValue, oldValue) => {
    //   console.log(`Query parameter changed from ${oldValue} to ${newValue}`);
    //   // Perform actions based on the new value
    // });
    return {route};
  },
  data() {
    return {
      searchClient: algoliasearch(
          'EQG67PIJL4',
          'fc04609e7aad921579cb789e167c6f92'
          // 'B1G2GM9NG0',
          // 'aadef574be1f9252bb48d4ea09b5cfe5'
      ),
      totalHits: 0,
      languageFacets: [],
      citiesfacets: [],
      statefacets: [],
      categoryFacets: [],
      routing: {
        stateMapping: {
          stateToRoute(uiState) {
            const indexUiState = uiState['jazyky_master'] || {};
            let routeState = {};
            // console.log(indexUiState);
            if (indexUiState.refinementList) {
              if (indexUiState.refinementList['languages.name'] && indexUiState.refinementList['languages.name'].length > 0) {
                routeState.languages = indexUiState.refinementList['languages.name'].join(',');
              }
              if (indexUiState.refinementList['categories.name'] && indexUiState.refinementList['categories.name'].length > 0) {
                routeState.categories = indexUiState.refinementList['categories.name'].join(',');
              }
              if (indexUiState.refinementList['states.name'] && indexUiState.refinementList['states.name'].length > 0) {
                routeState.states = indexUiState.refinementList['states.name'].join(',');
              }
              if (indexUiState.refinementList['cities.name'] && indexUiState.refinementList['cities.name'].length > 0) {
                routeState.city = indexUiState.refinementList['cities.name'].join(',');
              }
            }
            if (indexUiState.page && indexUiState.page !== 1) { // Předpokládá, že stránka 1 je výchozí
              routeState.page = indexUiState.page;
            }

            return routeState;
          },
          routeToState(routeState) {
            return {
              jazyky_master: {
                page: routeState.page,
                refinementList: {
                  'languages.name': routeState.languages ? routeState.languages.split(',') : [],
                  'categories.name': routeState.categories ? routeState.categories.split(',') : [],
                  'states.name': routeState.states ? routeState.states.split(',') : [],
                  'cities.name': routeState.city ? routeState.city.split(',') : [],
                },
              },
            };
          },
        },
      }
    };
  },
  methods: {
    transformLanguage(items) {
      return this.transformItems(items, this.languageFacets);
    },
    transformCities(items) {
      return this.transformItems(items, this.citiesfacets);
    },
    transformState(items) {
      return this.transformItems(items, this.statefacets);
    },
    transformCategory(items) {
      return this.transformItems(items, this.categoryFacets);
    },
    transformItems(items, facets) {
      // If Algolia doesn't return enough results, we lose track of a
      // potentially refined facet.
      // For example, if you refine on "Apple", then search for "chromecast",
      // "Apple" is no longer returned, and we don't know that it was selected
      // based on the initial facets.
      // We need to keep track of the last state to reflect the fact that it
      // was refined in the UI.
      facets.forEach((facet, index) => {
        const updatedItem = items.find(item => item.value === facet.value);

        if (updatedItem) {
          facets[index] = {
            ...updatedItem,
            count: 0,
          };
        }
      });

      // If a cached facet is already returned by Algolia, we want it to be
      // displayed rather than to display its cached value.
      // You might need to sort the items again here because the internal
      // sorting happens before `transformItems` is called.
      return uniqBy([...items, ...facets], 'value').slice(
          0,
          100
      );
    },
  },
  computed: {},
  mounted() {
    this.searchClient
        .searchForFacetValues([
          {
            indexName: 'jazyky_master',
            params: {
              facetName: 'languages.name',
              facetQuery: '',
              maxFacetHits: '100',
            },
          },
        ])
        .then(([{facetHits}]) => {
          this.languageFacets.push(
              ...facetHits.map(facet => ({
                ...facet,
                label: facet.value,
                value: facet.value,
                isRefined: false,
                count: 0,
              }))
          );
        });
    this.searchClient
        .searchForFacetValues([
          {
            indexName: 'jazyky_master',
            params: {
              facetName: 'cities.name',
              facetQuery: '',
              maxFacetHits: '100',
            },
          },
        ])
        .then(([{facetHits}]) => {
          this.citiesfacets.push(
              ...facetHits.map(facet => ({
                ...facet,
                label: facet.value,
                value: facet.value,
                isRefined: false,
                count: 0,
              }))
          );
        });
    this.searchClient
        .searchForFacetValues([
          {
            indexName: 'jazyky_master',
            params: {
              facetName: 'states.name',
              facetQuery: '',
              maxFacetHits: '100',
            },
          },
        ])
        .then(([{facetHits}]) => {
          this.statefacets.push(
              ...facetHits.map(facet => ({
                ...facet,
                label: facet.value,
                value: facet.value,
                isRefined: false,
                count: 0,
              }))
          );
        });
    this.searchClient
        .searchForFacetValues([
          {
            indexName: 'jazyky_master',
            params: {
              facetName: 'categories.name',
              facetQuery: '',
              maxFacetHits: '100',
            },
          },
        ])
        .then(([{facetHits}]) => {
          this.categoryFacets.push(
              ...facetHits.map(facet => ({
                ...facet,
                label: facet.value,
                value: facet.value,
                isRefined: false,
                count: 0,
              }))
          );
        });
  }
}
</script>

<style>
.ais-Hits-list {

}

.ais-Pagination-item {
  /*background-color: white;*/
  /*border: 1px solid #e9ecef;*/
  /*padding-left: 5px;*/
  /*padding-right: 5px;*/
  /*border-radius: 5px;*/
  /*text-decoration: none !important;*/


  /*margin: 0px !important;*/
}

.ais-Pagination-item a {
  text-decoration: none;
}

.ais-RefinementList-showMore--disabled {
  display: none;
}

.ais-RefinementList-count{
  background-color: transparent;
}

</style>
